<template>
	<div>
		<!-- <el-form :inline="true" :model="searchForm" ref="searchForm">
			<el-form-item label="持卡人姓名" prop="cardName" label-width="100px">
				<el-input v-model="searchForm.cardName" placeholder="持卡人姓名" clearable> </el-input>
			</el-form-item>
			<el-form-item label="审核状态" prop="status" label-width="100px">
				<el-select v-model="searchForm.status" filterable placeholder="审核状态">
					<el-option v-for="(item, index) in typeList" :key="index" :label="item.name" clearable
						:value="item.id">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="getTixianList()">搜索</el-button>
			</el-form-item>
			<el-form-item>
				<el-button type="success" @click="resetForm('searchForm')">重置</el-button>
			</el-form-item>
		</el-form> -->

		<el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%;" border stripe
			@selection-change="handleSelectionChange">
			<el-table-column align="center" label="姓名" prop="nickName"></el-table-column>
			<el-table-column align="center" label="手机号" prop="phone"></el-table-column>
			<el-table-column align="center" label="门店号" prop="shopNumber"></el-table-column>


			<el-table-column prop="monthSettlement" align="center" label="结算月份"></el-table-column>
			<el-table-column align="center" label="开票金额" prop="billingAmount"></el-table-column>
			<el-table-column prop="status" align="center" label="状态">
				<template slot-scope="scope">
					<el-tag size="small" v-if="scope.row.status === 0" type="info"> 未结算 </el-tag>
					<el-tag size="small" v-else-if="scope.row.status === 1" type="success"> 已结算 </el-tag>

				</template>
			</el-table-column>
			<el-table-column prop="createTime" align="center" label="创建时间"></el-table-column>
			<el-table-column prop="icon" align="center" fixed="right" label="操作">
				<template slot-scope="scope">
					<!-- <el-button type="warning" plain @click="watch(scope.row)">查看详情</el-button> -->
					<el-button type="primary" plain @click="reviewButton(scope.row)"
						v-if="scope.row.status == 0">已结算</el-button>
				</template>
			</el-table-column>
		</el-table>
		<!-- 分页器 -->
		<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
			layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100]" :current-page="current"
			:page-size="size" :total="total"></el-pagination>
		<!-- 对话框 -->
		<!-- <el-dialog title="添加规格分类" :visible.sync="dialogVisible" :close-on-click-modal="false"
            :before-close="handleClose">
            <el-form :model="editForm" ref="editForm" :rules="rules" label-width="120px" class="demo-editForm">
                <el-form-item label="状态：" prop="status" label-width="100px">
                    <el-radio-group v-model="editForm.status">
                        <el-radio :label="1">审核通过</el-radio>
                        <el-radio :label="2">审核驳回</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item :label="(editForm.status == 2 ? '驳回':'通过') + '说明：'" label-width="100px"
                    prop="note">
                    <el-input type="textarea" :rows="4" placeholder="请输入内容" v-model="editForm.note"></el-input>
                </el-form-item>
                <el-form-item align="center">
                    <el-button type="primary" @click="submitForm('editForm')">
                        提交
                    </el-button>
                </el-form-item>
            </el-form>
        </el-dialog> -->
		<!-- 提现详情对话框 -->
		<el-dialog title="提现详情" :visible.sync="dialogVisible2" :close-on-click-modal="false"
			:before-close="handleClose2">
			<div class="msg-list">
				<div class="msg-title">用户头像：</div>
				<div class="msg-content">
					<img :src="watchForm.avatarUrl" alt="" height="50px">
				</div>
			</div>
			<div class="msg-list">
				<div class="msg-title">用户昵称：</div>
				<div class="msg-content">{{ watchForm.nickName }}</div>
			</div>
			<div class="msg-list">
				<div class="msg-title">持卡人姓名：</div>
				<div class="msg-content">{{ watchForm.cardName }}</div>
			</div>
			<div class="msg-list">
				<div class="msg-title">开户银行：</div>
				<div class="msg-content">{{ watchForm.accountBank }}</div>
			</div>
			<div class="msg-list">
				<div class="msg-title">银行卡号：</div>
				<div class="msg-content">{{ watchForm.cardNumber }}</div>
			</div>
			<div class="msg-list">
				<div class="msg-title">手机号：</div>
				<div class="msg-content">{{ watchForm.phone }}</div>
			</div>
			<div class="msg-list">
				<div class="msg-title">状态：</div>
				<div class="msg-content" v-if="watchForm.status == 0">待审核</div>
				<div class="msg-content" v-else-if="watchForm.status == 1">审核通过</div>
				<div class="msg-content" v-else-if="watchForm.status == 2">审核驳回</div>
				<div class="msg-content" v-else-if="watchForm.status == 3">转账成功</div>
			</div>
			<div class="msg-list">
				<div class="msg-title">提现金额：</div>
				<div class="msg-content" style="font-weight: 800;">{{ watchForm.withdrawalAmount }}</div>
			</div>
			<div class="msg-list" style="opacity: 0.5;">
				<div class="msg-title">当前余额：</div>
				<div class="msg-content">{{ watchForm.nowMoney }}</div>
			</div>
			<div class="msg-list">
				<div class="msg-title">说明：</div>
				<div class="msg-content">{{ watchForm.note }}</div>
			</div>
			<div class="msg-list">
				<div class="msg-title">申请时间：</div>
				<div class="msg-content">{{ watchForm.createTime }}</div>
			</div>
			<span slot="footer" class="dialog-footer" v-if="watchForm.status == 1">
				<el-button type="primary" @click="ConfirmTix">确认转账</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		param
	} from 'jquery';

	export default {
		name: 'revenuelist',
		data() {
			return {
				//搜索数据
				searchForm: {
					cardName: '',
					status: ''
				},
				editForm: {
					id: '',
					userId: '',
					status: '',
					note: '',
					withdrawalAmount: ''
				},
				watchForm: {},
				tableData: [],
				total: 0,
				// 每页多少数据
				size: 10,
				// 那一页
				current: 1,
				typeList: [{
						name: '待审核',
						id: 0
					},
					{
						name: '审核通过',
						id: 1
					},
					{
						name: '审核驳回',
						id: 2
					},
					{
						name: '转账成功',
						id: 3
					}
				],
				//对话框是否展示
				dialogVisible: false,
				dialogVisible2: false,
				rules: {
					status: [{
						required: true,
						message: '请选择审核状态',
						trigger: 'change'
					}],
					note: [{
						required: true,
						message: '请输入说明',
						trigger: 'blur'
					}]
				}
			}
		},
		created() {
			this.getTixianList()
		},
		methods: {
			resetForm(formName) {
				this.$refs[formName].resetFields();
				this.dialogVisible = false
				this.getTixianList()
			},
			handleSelectionChange(val) {
				// this.multipleSelection = val
				// this.delBtlStatu = val.length == 0
			},

			handleSizeChange(val) {
				console.log('size changed', val);
				this.size = val
				this.getTixianList()
			},
			handleCurrentChange(val) {
				console.log('current changed', val);
				this.current = val
				this.getTixianList()
			},
			// 关闭对话框触发事件
			handleClose() {
				this.dialogVisible = false
				this.resetForm('editForm')
				this.editForm = {
					id: '',
					userId: '',
					status: '',
					note: ''
				}
			},
			handleClose2() {
				this.dialogVisible2 = false
				this.watchForm = {}
			},
			//列表
			getTixianList() {
			
			
				this.$axios.get('admin/userBillingSettlement/getTBillingSettlementList', {
					params:{
						pageNo:this.current,
						pageSize: this.size
					}
				}).then((res) => {
					console.log(33333333, res);
					this.tableData = res.data.records
					this.size = res.data.size
					this.current = res.data.current
					this.total = res.data.total
				})
			},
			//审核
			reviewButton(row) {
				// this.dialogVisible = true
				// this.editForm.id = row.id
				// this.editForm.userId = row.userId
				// this.editForm.withdrawalAmount=row.withdrawalAmount
				var that = this
				that.$alert('确定已经开票打款了吗？', '提示', {
					confirmButtonText: '确定',
					callback: action => {
						if (action == 'confirm') {

							that.$axios.post('/admin/userBillingSettlement/tBillingSettlement', {
								id: row.id
							}).then((res) => {
								if (res.code == 0) {
									that.getTixianList()
								}
							})
						}
					}
				});
			},
			submitForm() {
				this.$refs.editForm.validate((valid) => {
					if (valid) {
						console.log(this.editForm);
						this.$axios.post('/admin/userWithdrawal/applyWithdrawal', this.editForm).then((res) => {
							if (res.code == 0) {
								this.getTixianList()
								this.handleClose()
								this.$message({
									showClose: true,
									message: '恭喜你，操作成功',
									type: 'success',
								})
							}
						})
					}
				});
			},
			watch(row) {
				console.log(row);
				this.dialogVisible2 = true
				this.watchForm = row
			},
			ConfirmTix() {
				this.$confirm('确认转账?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$axios.post('/admin/userWithdrawal/submitWithdrawal', {
						id: this.watchForm.id
					}).then((res) => {
						if (res.code == 0) {
							this.getTixianList()
							this.handleClose2()
							this.$message({
								type: 'success',
								message: '提交成功'
							});
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
			}
		},
	}
</script>

<style scoped>
	.el-button {
		padding: 0 10px;
		height: 35px;
		line-height: 35px;
		font-size: 15px;
		margin-right: 10px;
	}

	.msg-list {
		margin-top: 10px;
		font-size: 18px;
		line-height: 40px;
		display: flex;
		align-items: center;
		color: #000;
	}

	.msg-title {
		width: 150px;
		text-align: right;
	}

	img {
		vertical-align: middle;
	}
</style>